export default __webpack_public_path__ + "static/media/hood_of_the_doomsayer.577da5aa.jpg";